import React from 'react';

const AppointmentAdminForm = ({ mode, setmode, formdata, setformdata, handlesubmit, handlecancel }) => {
  if (mode !== "editappointment") return null;

  const alreadyCancelled = formdata.status === "Cancelled";

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Edit Appointment</h3>
          <button className="close-btn" onClick={() => setmode("")}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Name</label>
            <input
              type="text"
              className="form-input"
              value={formdata.name}
              onChange={(e) => setformdata({ ...formdata, name: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="text"
              className="form-input"
              value={formdata.phonenumber}
              onChange={(e) => setformdata({ ...formdata, phonenumber: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label>Date</label>
            <input
              type="date"
              className="form-input"
              value={formdata.date}
              onChange={(e) => setformdata({ ...formdata, date: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label>Time</label>
            <input
              type="time"
              className="form-input"
              value={formdata.time}
              onChange={(e) => setformdata({ ...formdata, time: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label>Comment</label>
            <textarea
              className="form-input"
              rows={4}
              value={formdata.comment}
              onChange={(e) => setformdata({ ...formdata, comment: e.target.value })}
            />
          </div>
          <div style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
            <button className="btn-blue" style={{ flex: 1 }} onClick={handlesubmit}>Save</button>
            <button
              className="btn-accent"
              style={{ flex: 1 }}
              onClick={handlecancel}
              disabled={alreadyCancelled}
            >
              Cancel Appointment
            </button>
          </div>
          {alreadyCancelled && (
            <p className="muted-sm" style={{ marginTop: '6px', textAlign: 'right' }}>Already cancelled</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppointmentAdminForm;
